var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#141619"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6517 14.35C24.2017 12.9 22.2117 12 20.0017 12C15.5817 12 12.0117 15.58 12.0117 20C12.0117 24.42 15.5817 28 20.0017 28C23.7317 28 26.8417 25.45 27.7317 22H25.6517C24.8317 24.33 22.6117 26 20.0017 26C16.6917 26 14.0017 23.31 14.0017 20C14.0017 16.69 16.6917 14 20.0017 14C21.6617 14 23.1417 14.69 24.2217 15.78L21.0017 19H28.0017V12L25.6517 14.35Z",
    fill: "#A2ADB8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#525F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshButton);
export default __webpack_public_path__ + "static/media/refresh-button.217ac0d5ab84f9c0b1a30aaacf81430d.svg";
export { ForwardRef as ReactComponent };